module.exports = __webpack_public_path__ + "static/media/v_logo-caf_2022.f3547ac4.svg";